import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import { updateCompany } from '../../../controller/companyController'; 

function EditCompanyView() {
  const location = useLocation();
  const navigate = useNavigate();
  const [company, setCompany] = useState(location.state?.company || {});
 
  const [originalCompany, setOriginalCompany] = useState(location.state?.company || {}); // Estado para almacenar los datos originales

  useEffect(() => {
    // Guardar los datos originales cuando la empresa se cargue
    setOriginalCompany(location.state?.company || {});
  }, [location.state?.company]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCompany({
      ...company,
      [name]: type === 'checkbox' ? checked : value,
    });
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    // Crear un objeto JSON con los datos modificados
    const updatedCompanyData = { ...company };

    // Solo incluir los campos modificados
    Object.keys(company).forEach((key) => {
      if (company[key] === originalCompany[key] || company[key] === undefined || company[key] === null) {
        delete updatedCompanyData[key]; // Eliminar las propiedades no modificadas
      }
    });

    console.log("Datos a enviar: ", updatedCompanyData);

    try {
   

      // Ahora, proceder con la actualización de los datos restantes de la empresa
      const updatedCompany = await updateCompany(company.id, updatedCompanyData);

      // Actualizar el estado original con los nuevos valores
      setOriginalCompany(updatedCompany);
      navigate(-1); // Regresar a la vista anterior
    } catch (error) {
      console.error('Error al actualizar la empresa:', error);
    }
  };

  return (
    <Container className="mt-4">
      <Row className="align-items-center mb-4">
        <Col><h1>Editar Empresa</h1></Col>
    
      </Row>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Nombre</Form.Label>
          <Form.Control type="text" name="name" value={company.name} onChange={handleChange} required />
        </Form.Group>



        <Form.Group className="mb-3">
          <Form.Label>Dirección</Form.Label>
          <Form.Control type="text" name="address" value={company.address} onChange={handleChange} />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Teléfono</Form.Label>
          <Form.Control type="text" name="phone_number" value={company.phone_number} onChange={handleChange} />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Correo Electrónico</Form.Label>
          <Form.Control type="email" name="email" value={company.email} onChange={handleChange} />
        </Form.Group>


        <Button variant="primary" type="submit" className="me-2">Guardar Cambios</Button>
        <Button variant="secondary" onClick={() => navigate(-1)}>Volver</Button>
      </Form>
    </Container>
  );
}

export default EditCompanyView;
